import React from "react";
import { t } from "@/lib/i18n";

/* ---------------------------------------------------------------------------
   "Listed" is a product name, not a word. Wherever it appears in running copy
   it is set in the wordmark's face (see .brand-word in index.css) so a reader
   sees the brand, not the past participle of "list".

   brandify("Listed puts an estimate…") → ["", <span class="brand-word">Listed</span>, " puts an estimate…"]
   tb(key, vars) → brandify(t(key, vars))  — for JSX children only (never attributes).
--------------------------------------------------------------------------- */

const SPLIT = /(\bListed\b)/;

export function brandify(text) {
  if (typeof text !== "string" || !text.includes("Listed")) return text;
  const parts = text.split(SPLIT);
  if (parts.length === 1) return text;
  return parts.map((p, i) => (p === "Listed" ? <span key={i} className="brand-word">Listed</span> : p));
}

export const tb = (key, vars) => brandify(t(key, vars));
